/** @jsx jsx */
import { jsx } from 'theme-ui'
import React, { useEffect, useState } from 'react'
import ToggleSwitch from './toggle-switch'
import { track } from '../../utils/tracking'
import { CONSENT_COOKIE, readCookie, readCookieRaw, updateConsentCookie } from '../../utils/cookies'
import Icon from '../../atoms/icon'

const trackPreferenceChange = (name, value) =>
  track({
    action: 'toggled',
    label: JSON.stringify({ name, value }),
    category: CONSENT_COOKIE,
    interactive: true,
  })

const updateNerdalytics = () => {
  if (window.nerdalytics) {
    const castConsent = readCookie(CONSENT_COOKIE)
    if (castConsent) {
      window.nerdalytics.setContext({ castPermissions: castConsent })
    }
  }
}

const sendIdentifyEvent = () => {
  if (window.nerdalytics) {
    const usci = readCookieRaw('usci')
    window.nerdalytics.identify(usci || '')
  }
}

const CookieToggle = ({ type, acceptedText = 'On', declinedText = 'Off', className }) => {
  const [toggleState, setToggleState] = useState(false)
  const id = `${type}-cookie-toggle`

  useEffect(() => {
    const consentCookie = readCookie(CONSENT_COOKIE)
    setToggleState(consentCookie ? consentCookie[type] : false)
  }, [type])

  const handleOnChange = () => {
    const newState = !toggleState
    setToggleState(newState)
    trackPreferenceChange(type, newState)
    updateConsentCookie(type, newState)
    updateNerdalytics()
    sendIdentifyEvent()
  }

  return (
    <div
      sx={{
        display: 'flex',
        paddingBottom: 'md',
      }}
      className={className}
    >
      <Choose>
        <When condition={type === 'essential'}>
          <Icon glyph={'tick-circle'} size={32} />
        </When>
        <Otherwise>
          <ToggleSwitch id={id} checked={toggleState} onChange={handleOnChange} />
        </Otherwise>
      </Choose>
      <label
        sx={{
          marginLeft: 'sm',
          display: 'flex',
          alignItems: 'center',
        }}
        htmlFor={id}
      >
        {toggleState ? acceptedText : declinedText}
      </label>
    </div>
  )
}

export default CookieToggle
